export const NO_DEBTOR_ID = 'debdebde-debd-debd-debd-111111111111';